import * as React from "react";
import * as styles from "./style.module.css";

interface LoaderProps {
  children: React.ReactNode;
  show: boolean;
  style?: React.CSSProperties;
}

export function Loader(props: LoaderProps) {
  const { show, children, style } = props;

  return (
    <div className={styles.loader} style={style}>
      {show ? <div className={styles.overlay}>Loading...</div> : ""}
      {children}
    </div>
  );
}
